import React from 'react'

const PageLoader = () => (
    <div className="js-loader-wrapper">
        <div className="js-loader"></div>
    </div>
)

export default PageLoader